import { Component, ElementRef, OnInit } from '@angular/core';

/**
 * @ignore
 */
@Component({
  selector: 'uex-card-deck',
  templateUrl: './deck.component.html',
  host: {
    class: 'uex-card-deck card-deck'
  }
})
export class CardDeckComponent implements OnInit {
  constructor(
    public elementRef: ElementRef
  ) { }

  ngOnInit() { }
}
